import { render, staticRenderFns } from "./tel-admin.vue?vue&type=template&id=da1ecddc"
import script from "./tel-admin.vue?vue&type=script&lang=ts"
export * from "./tel-admin.vue?vue&type=script&lang=ts"
import style0 from "./tel-admin.vue?vue&type=style&index=0&id=da1ecddc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports